import { useQuery } from '@tanstack/react-query';
import { costHistoryService, CostHistoryFilters } from '@/services/costHistory';

// Hook para obtener historial general
export function useCostHistory(filters?: CostHistoryFilters) {
  return useQuery({
    queryKey: ['cost-history', filters],
    queryFn: () => costHistoryService.getCostHistory(filters),
  });
}

// Hook para obtener historial de un producto específico
export function useProductCostHistory(productId: number, limit = 50) {
  return useQuery({
    queryKey: ['cost-history', 'product', productId, limit],
    queryFn: () => costHistoryService.getProductCostHistory(productId, limit),
    enabled: !!productId,
  });
}

// Hook para obtener estadísticas de costos de un producto
export function useProductCostStatistics(productId: number) {
  return useQuery({
    queryKey: ['cost-statistics', productId],
    queryFn: () => costHistoryService.getProductCostStatistics(productId),
    enabled: !!productId,
  });
}

// Hook para obtener productos con mayor aumento de costo
export function useTopCostIncreases(days = 30, limit = 10) {
  return useQuery({
    queryKey: ['cost-increases', days, limit],
    queryFn: () => costHistoryService.getTopCostIncreases(days, limit),
  });
}
